<template>
  <div class="home-page">
    <!-- 视觉焦点区：英雄轮播 + 视差装饰 + 向下引导 -->
    <div class="s_carousel-container">
      <div
          v-for="(slide, index) in slides"
          :key="index"
          class="s_carousel-item"
          v-show="currentSlide === index"
          :aria-hidden="currentSlide !== index"
      >
        <div class="s_carousel-caption" data-aos="fade-up">
          <div class="s_caption-eyebrow" data-aos="zoom-in" data-aos-delay="50">
            SHANYUANMEIXIAO
          </div>
          <h2 data-aos="fade-up" data-aos-delay="100">{{ slide.title }}</h2>
          <p data-aos="fade-up" data-aos-delay="250">{{ slide.description }}</p>
          <router-link
              v-if="slide.link"
              :to="slide.link"
              class="s_btn s_btn-primary"
              data-aos="fade-up"
              data-aos-delay="450"
          >
            了解更多
          </router-link>
        </div>
      </div>

      <!-- 指示点 -->
      <div class="s_carousel-dots">
      <span
          v-for="(slide, i) in slides"
          :key="i"
          :class="{ active: i === currentSlide }"
          @click="currentSlide = i"
      ></span>
      </div>
    </div>

    <!-- 快速链接（加微交互动效） -->
    <div id="section-fast" class="quick-links">
      <div class="container">
        <h2 class="section-title">快速通道</h2>
        <div class="links-grid">
          <router-link
              v-for="(link, index) in quickLinks"
              :key="index"
              :to="link.path"
              class="link-card tilt"
              data-aos="fade-up"
          >
            <div class="link-icon">
              <i class="c-theme" :class="link.icon"></i>
            </div>
            <h3>{{ link.title }}</h3>
            <p>{{ link.description }}</p>
          </router-link>
        </div>
      </div>
    </div>

    <!-- 数据成就统计 -->
    <section class="stats-section" v-show="false">
      <div class="container">
        <div class="stats-grid">
          <div class="stat-item" v-for="(s, i) in stats" :key="i" ref="statItems" data-aos="zoom-in" :data-target="s.value">
            <div class="stat-value">{{ s.display }}</div>
            <div class="stat-label">{{ s.label }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 特色展示（左右错落 + 装饰线） -->
    <div class="featured-section">
      <div class="container">
        <h2 class="section-title">学校特色</h2>
        <div class="featured-content">
          <div class="featured-text">
            <p data-aos="fade-right">&emsp;&emsp;长治市杉原美术培训学校是经长治市教育局批准成立的一所专注于美术高考的专业教育机构，于2003年5月开始办学。经过二十余年的不懈努力，现已成为山西省美术教育最具竞争力的知名学校！</p>
            <p data-aos="fade-right">&emsp;&emsp;我校以“用更优的美术教育圆更多学子的大学梦想”作为学校使命，继承“为了学生一切，一切为了学生”的服务理念，以“励志、勤学、尚美、卓越”作为学校师生的总要求，以“引导学生走上艺术道路，唤醒学生对艺术和人生的思考”作为我们的办学理念。  </p>
            <p data-aos="fade-right">&emsp;&emsp;我校现有专职教师30余人，教师均毕业于全国各大艺术院校。建校20余年来，每年培训的学员约300余人，三次夺得山西省美术统考第一名，为长治地区的美术教育发展做出了贡献！  </p>
            <p data-aos="fade-right">&emsp;&emsp;杉原美术学校经过二十余年的摸索、研究，已经形成了一套先进完整的教学体系，使求学于此的每位学子都能得到耐心的辅导、精心的培育、细心的呵护、贴心的教诲，学子因选择杉原而幸运，杉原因学子成长而精彩。杉原人将不负众望、恪尽职守、立足上党、放眼三晋，努力攀登新的高峰！  </p>
            <p data-aos="fade-right">&emsp;&emsp;你若来，我便帮你去你想去的未来！</p>
          </div>
          <div class="featured-image">
            <img :src="featuredContent.image" alt="学校特色">
          </div>
        </div>
      </div>
    </div>

    <!-- 品牌背书/合作院校 -->
    <section class="partners-section" v-show="false">
      <div class="container">
        <h2 class="section-title">品牌与荣誉</h2>
        <div class="partners-grid">
          <div class="partner-item" v-for="(p, i) in partners" :key="i" data-aos="fade-up" :data-aos-delay="i * 60">
            <img :src="p.src" :alt="p.alt">
          </div>
        </div>
      </div>
    </section>

    <!-- 优秀作品展示（胶片框/浮层阴影） -->
    <div class="works-showcase" data-aos="fade-right">
      <div class="container">
        <h2 class="section-title">优秀学员</h2>
        <Gallery :images="studentWorks" />
        <!--<router-link to="/works" class="btn view-more">-->
        <!--  查看更多作品-->
        <!--</router-link>-->
      </div>
    </div>

    <!-- 页面中部 CTA 横幅 -->
    <section class="mid-cta" data-aos="zoom-in">
      <div class="container mid-cta-inner">
        <h3>开启你的艺术成长之旅</h3>
        <p>现在咨询课程，获取专业的升学规划与作品点评建议。</p>
        <div class="contact-info" style="margin: 15px 0; color: #666; font-size: 14px;">
          <div style="display: flex; align-items: center; justify-content: center; gap: 20px; flex-wrap: wrap;">
            <div style="display: flex; align-items: center;">
              <span style="margin-right: 8px;">📞</span>
              <a href="tel:15935527382" style="color: #FDAA02; text-decoration: none;">159-3552-7382（张老师）</a>
            </div>
            <!--<div style="width: 1px; height: 16px; background: #ddd;"></div>-->
            <div style="display: flex; align-items: center;">
              <span style="margin-right: 8px;">📞</span>
              <a href="tel:15584455300" style="color: #FDAA02; text-decoration: none;">155-8445-5300（李老师）</a>
            </div>
            <div style="display: flex; align-items: center;">
              <span style="margin-right: 8px;">📞</span>
              <a href="tel:15383553367" style="color: #FDAA02; text-decoration: none;">153-8355-3367（郝老师）</a>
            </div>
          </div>
        </div>
        <div class="actions">
          <router-link to="/history" class="btn btn-primary">查看升学数据</router-link>
          <router-link to="/environment" class="btn btn-primary">参观校园</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Gallery from '@/components/Gallery.vue'

export default {
  name: 'HomePage',
  components: {
    Gallery
  },
  data() {
    return {
      currentSlide: 0,
      isHoveringHero: false,
      slides: [
        {
          image: require('@/assets/resources/学校环境介绍/4db7263459b6da311d945c4641f65f0.jpg'),
          title: '欢迎来到杉原美校',
          description: '培养艺术创造力，塑造未来艺术家',
          link: '/history'
        },
        {
          image: require('@/assets/resources/教师介绍/教师形象照/刘俊.jpg'),
          title: '卓越的师资团队',
          description: '由专业艺术教育家组成的教师团队',
          link: '/teachers'
        },
        {
          image: require('@/assets/resources/学校环境介绍/4a6e6818cb0d9fdc7ba9925db9e1aaee.jpg'),
          title: '现代化的教学设施',
          description: '提供一流的艺术创作环境和设备',
          link: '/environment'
        }
      ],
      quickLinks: [
        {
          title: '学校介绍',
          description: '了解我们的历史与理念',
          path: '/about',
          icon: 'fas fa-landmark'
        },
        {
          title: '历史成绩',
          description: '查看历年学生成就',
          path: '/history',
          icon: 'fas fa-trophy'
        },
        {
          title: '学校环境',
          description: '虚拟参观我们的校园',
          path: '/environment',
          icon: 'fas fa-university'
        },
        {
          title: '师资介绍',
          description: '认识我们的教师团队',
          path: '/teachers',
          icon: 'fas fa-chalkboard-teacher'
        },
        // {
        //   title: '校园设施',
        //   description: '了解我们的专业设施',
        //   path: '/facilities',
        //   icon: 'fas fa-building'
        // },
        // {
        //   title: '优秀作业',
        //   description: '欣赏学生优秀作品',
        //   path: '/works',
        //   icon: 'fas fa-images'
        // }
      ],
      featuredContent: {
        title: '杉原美校教育特色',
        description: '杉原美校提供专业的美术教育，注重个性化培养，结合传统艺术技法与现代创意表达。学校拥有专业的教学设施和优秀的师资团队，为学生提供丰富的学习资源和展示平台，帮助学生实现艺术梦想。',
        image: require('@/assets/resources/学校环境介绍/3114e807585ad9e04881821931b7fa3b.jpg')
      },
      studentWorks: [
        {
          src: require('@/assets/resources/优秀学员/6.jpg'),
          alt: '优秀学员作品',
          caption: '王旭峰'
        },
        {
          src: require('@/assets/resources/优秀学员/7.jpg'),
          alt: '优秀学员作品',
          caption: '林伟静'
        },
        {
          src: require('@/assets/resources/优秀学员/8.jpg'),
          alt: '优秀学员作品',
          caption: '荣周涛'
        }
      ],
      stats: [
        { label: '累计培养学员', value: 5000, display: '0+' },
        { label: '近三年升学率', value: 98, display: '0%' },
        { label: '一本双一流录取', value: 320, display: '0+' },
        { label: '省统考状元次数', value: 3, display: '0次' }
      ],
      partners: [
        { src: require('@/assets/images/trend-award.png'), alt: '权威奖项' },
        { src: require('@/assets/images/trend-exhibition.png'), alt: '专业展览' },
        { src: require('@/assets/images/trend-advancement.png'), alt: '升学优势' },
        { src: require('@/assets/images/trend-score.png'), alt: '成绩口碑' }
      ]
    }
  },
  methods: {
    makePhone(phone) {
      window.location.href = `tel:${phone}`;
    },
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.slides.length
    },
    prevSlide() {
      this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length
    },
    goToSlide(index) {
      this.currentSlide = index
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      return `${date.getMonth() + 1}月${date.getDate()}日`
    },
    startCarousel() {
      this.carouselInterval = setInterval(() => {
        if (!this.isHoveringHero) this.nextSlide()
      }, 5000)
    },
    handleMouseEnterHero() {
      this.isHoveringHero = true
    },
    handleMouseLeaveHero() {
      this.isHoveringHero = false
    },
    pauseCarousel() {
      this.isHoveringHero = true
    },
    resumeCarousel() {
      this.isHoveringHero = false
    },
    startCountUp(entry, index) {
      const target = this.stats[index].value
      const suffix = this.stats[index].label.includes('率') ? '%' : (this.stats[index].label.includes('次') ? '次' : '+')
      const duration = 1200
      const start = performance.now()
      const tick = (now) => {
        const p = Math.min(1, (now - start) / duration)
        const val = Math.floor(target * (0.15 + 0.85 * p))
        this.$set(this.stats[index], 'display', `${val}${suffix}`)
        if (p < 1) requestAnimationFrame(tick)
      }
      requestAnimationFrame(tick)
    }
  },
  mounted() {
    this.startCarousel()
    // 统计数字进入视口后开始滚动
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          const idx = Array.from(this.$refs.statItems).indexOf(e.target)
          if (idx > -1 && this.stats[idx].display === '0+' || this.stats[idx].display === '0%' || this.stats[idx].display === '0次') {
            this.startCountUp(e, idx)
          }
          observer.unobserve(e.target)
        }
      })
    }, { threshold: 0.4 })
    this.$nextTick(() => {
      this.$refs.statItems && this.$refs.statItems.forEach(el => observer.observe(el))
    })
  },
  beforeDestroy() {
    clearInterval(this.carouselInterval)
  }
}
</script>

<style scoped>
.home-page {
  overflow-x: hidden;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  text-align: center;
  font-size: 2rem;
  margin-bottom: 2rem;
  color: #2c3e50;
  position: relative;
  padding-bottom: 15px;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background-color: var(--default-red-color);
}

.btn {
  display: inline-block;
  padding: 10px 20px;
  background-color: var(--default-red-color);
  color: white;
  text-decoration: none;
  transition: all 0.3s;
  border: none;
  cursor: pointer;
  border-radius: 5px;
}

.btn:hover {
  background-color: #3aa876;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.btn-outline {
  background-color: transparent;
  border: 2px solid var(--default-red-color);
  color: var(--default-red-color);
}

.btn-outline:hover {
  background-color: var(--default-red-color);
  color: white;
}

/* 轮播图样式 */
.hero-carousel {
  position: relative;
  width: 100%;
  height: 80vh;
  min-height: 500px;
  overflow: hidden;
}

.carousel-inner {
  position: relative;
  width: 100%;
  height: 100%;
}

.carousel-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 1s ease;
}

.carousel-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: inherit;
}

/* Ken Burns 轻微缩放与平移，提升沉浸感（作用于图片本身） */
.kenburns {
  transform: scale(1.06);
  animation: kenburns 12s ease-in-out infinite alternate;
}

@keyframes kenburns {
  0% { transform: scale(1.06) translate3d(0,0,0); }
  100% { transform: scale(1.12) translate3d(-2%, -2%, 0); }
}

.carousel-caption {
  position: absolute;
  bottom: 20%;
  left: 10%;
  max-width: 600px;
  padding: 30px;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  border-radius: 5px;
}

.caption-eyebrow {
  font-size: 0.8rem;
  letter-spacing: 0.35em;
  /*color: #a3ffd6;*/
  color: #FDAA02;
  opacity: 0.9;
  margin-bottom: 0.5rem;
}

.carousel-caption h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.carousel-caption p {
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
}

.carousel-control {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 10;
}

.carousel-control.prev {
  left: 20px;
}

.carousel-control.next {
  right: 20px;
}

.carousel-control:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

.carousel-indicators {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
}

.carousel-indicators span {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
}

.carousel-indicators span.active {
  background-color: white;
}

/* 视差装饰元素 */
.parallax-shape {
  position: absolute;
  top: -80px;
  right: -80px;
  width: 380px;
  height: 380px;
  filter: blur(0.2px);
  opacity: 0.6;
  pointer-events: none;
}

/* 快速链接样式 */
.quick-links {
  padding: 60px 0;
  background-color: #f8f9fa;
}

.links-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.link-card {
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  text-align: center;
  transition: all 0.3s;
  text-decoration: none;
  color: #333;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.link-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

/* 轻微 3D 倾斜效果（配合 GPU 加速） */
.tilt {
  will-change: transform;
  transform-style: preserve-3d;
}
.tilt:hover {
  transform: translateY(-6px) rotateX(2deg) rotateY(-2deg);
}

.link-icon {
  font-size: 2.5rem;
  color: var(--default-red-color);
  margin-bottom: 1rem;
}

.link-card h3 {
  margin-bottom: 0.5rem;
  color: #2c3e50;
}

.link-card p {
  color: #7f8c8d;
}

/* 特色展示样式 */
.featured-section {
  padding: 60px 0;
}

.featured-content {
  display: flex;
  align-items: center;
  gap: 40px;
}

.featured-section .section-title {
  position: relative;
}
.featured-section .section-title::before {
  content: '';
  position: absolute;
  width: 60px;
  height: 6px;
  background: linear-gradient(90deg, var(--default-red-color), rgba(66,185,131,0));
  left: 50%;
  top: -12px;
  transform: translateX(-50%);
  border-radius: 6px;
}

.featured-text {
  flex: 1;
}

.featured-text h3 {
  font-size: 1.8rem;
  color: #2c3e50;
  margin-bottom: 1.5rem;
}

.featured-text p {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #555;
  margin-bottom: 2rem;
}

.featured-image {
  flex: 1;
}

.featured-image img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

/* 作品展示样式 */
.works-showcase {
  padding: 60px 0;
  background-color: #f8f9fa;
}

/* 数据成就统计 */
.stats-section { padding: 40px 0; background: #ffffff; }
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 20px;
}
.stat-item {
  background: #f9fbfa;
  border: 1px solid #eef2ef;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 10px 20px rgba(0,0,0,0.02);
}
.stat-value {
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
}
.stat-label { color: #6b7a85; margin-top: 6px; }

/* 品牌背书 */
.partners-section { padding: 50px 0; }
.partners-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 24px;
  align-items: center;
}
.partner-item {
  background: #ffffff;
  border: 1px solid #eef2ef;
  border-radius: 10px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}
.partner-item:hover { transform: translateY(-4px); box-shadow: 0 10px 24px rgba(0,0,0,0.06); }
.partner-item img { max-width: 120px; height: auto; object-fit: contain; filter: saturate(0.85) contrast(1.05); }

/* 中部 CTA */
.mid-cta { padding: 50px 0; }
.mid-cta-inner {
  /*background: radial-gradient(600px 120px at 10% -10%, rgba(66,185,131,0.22), transparent),
              radial-gradient(700px 160px at 90% -10%, rgba(44,62,80,0.18), transparent);*/
  background: radial-gradient(600px 120px at 10% -10%, rgba(254, 252, 210, 0.22), transparent),
  radial-gradient(700px 160px at 90% -10%, rgba(44,62,80,0.18), transparent);
  border: 1px solid #eaf2ee;
  border-radius: 14px;
  padding: 28px 24px;
  text-align: center;
}
.mid-cta-inner h3 { margin: 0 0 8px 0; font-size: 22px; color: #2c3e50; }
.mid-cta-inner p { margin: 0 0 14px 0; color: #6b7a85; }
.mid-cta-inner .actions { display: inline-flex; gap: 12px; }
.btn-primary { background-color: var(--default-bg-theme); color: rgba(0, 0, 0, 0.8); }
.btn-outline { background-color: transparent; border: 2px solid #FDAA02; color: rgba(0, 0, 0, 0.8); }
.btn-primary:hover { background-color: var(--default-bg-theme); }
.btn-outline:hover { background-color: #fffdd9; color: rgba(0, 0, 0, 0.8); }

.view-more {
  display: block;
  width: 200px;
  margin: 30px auto 0;
  text-align: center;
}
.news-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s;
}

.news-card:hover .news-image img {
  transform: scale(1.05);
}

.read-more {
  color: var(--default-red-color);
  text-decoration: none;
  font-weight: bold;
}

.read-more:hover {
  text-decoration: underline;
}

/* 招生横幅样式 */
.admission-banner {
  background-color: #2c3e50;
  color: white;
  padding: 60px 0;
  text-align: center;
}

.admission-banner h2 {
  font-size: 2.2rem;
  margin-bottom: 1rem;
}

.admission-banner p {
  font-size: 1.2rem;
  margin-bottom: 2rem;
  opacity: 0.9;
}

.admission-banner .btn {
  background-color: var(--default-red-color);
  font-size: 1.1rem;
  padding: 12px 30px;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .hero-carousel {
    height: 60vh;
  }

  .carousel-caption h2 {
    font-size: 2rem;
  }

  .featured-content {
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .hero-carousel {
    height: 246px;
    min-height: 200px;
  }

  .carousel-caption {
    bottom: 10%;
    left: 5%;
    right: 5%;
    max-width: none;
  }

  .carousel-caption h2 {
    font-size: 1.8rem;
  }

  .carousel-caption p {
    font-size: 1rem;
  }

  .section-title {
    font-size: 1.8rem;
  }
  .partners-grid { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 576px) {
  .hero-carousel {
    height: 246px;
    min-height: 200px;
  }

  .carousel-caption {
    padding: 15px;
  }

  .carousel-caption h2 {
    font-size: 1.5rem;
  }

  .links-grid {
    grid-template-columns: 1fr;
  }

  .news-grid {
    grid-template-columns: 1fr;
  }
  .mid-cta-inner .actions { flex-direction: column; }
}

/* 过渡动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
<style scoped>
.s_carousel-container {
  position: relative;
  width: 100%;
  height: 70vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FDAA02;
  color: #333; /* 深灰文字，提升可读性 */
}

.s_carousel-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 1s ease;
}

.s_carousel-item[aria-hidden="true"] {
  opacity: 0;
  pointer-events: none;
}

.s_carousel-caption {
  text-align: center;
  max-width: 700px;
  padding: 0 20px;
}

.s_caption-eyebrow {
  font-size: 14px;
  letter-spacing: 2px;
  margin-bottom: 10px;
  color: #c97b00; /* 温暖的橙棕色强调文字 */
  text-transform: uppercase;
}

.s_carousel-caption h2 {
  font-size: 38px;
  margin-bottom: 16px;
  line-height: 1.3;
  font-weight: 700;
  color: #222;
}

.s_carousel-caption p {
  font-size: 18px;
  margin-bottom: 25px;
  color: #555;
}

.s_btn.s_btn-primary {
  background-color: #ff8c42;
  border: none;
  padding: 10px 28px;
  border-radius: 25px;
  color: #fff;
  font-weight: 600;
  transition: 0.3s;
}

.s_btn.s_btn-primary:hover {
  background-color: #ffac5c;
}

/* 指示点样式 */
.s_carousel-dots {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  text-align: center;
}

.s_carousel-dots span {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 0 6px;
  background-color: rgba(51, 51, 51, 0.4);
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s;
}

.s_carousel-dots span.active {
  background-color: #ff8c42;
  transform: scale(1.3);
}


@media (max-width: 768px) {
  .s_carousel-container {
    height: calc(100vh - 85px);
  }
}
</style>
